__turbopack_context__.v({
  "item": "uxLuCW_item",
  "items": "uxLuCW_items",
  "section": "uxLuCW_section",
});
